import { PremiumStoreListWrapper } from "../Style/PremiumStoreStyle";
import { useSearchContext } from "../../NewSearch/Hook/SearchContext";
import { PremiumStoreItem } from "./PremiumStoreItem";
import { useUI } from "../../NewSearch/Hook/UIContext";
import { memo } from "react";
import { useRecoilValue } from "recoil";
import { insetState } from "../../../../recoil/inset";

// PremiumStoreItem 메모이제이션
const MemoizedPremiumStoreItem = memo(PremiumStoreItem);

export const PremiumStoreList = () => {
  const { showStoreList } = useUI();
  const { recommendedList } = useSearchContext();
  const inset = useRecoilValue(insetState);

  return (
    <PremiumStoreListWrapper
      show={showStoreList}
      isTop={true}
      inset={inset}
      style={{ contentVisibility: "auto" }}
    >
      <div className="title">추천 홀덤펍</div>
      <div className="list">
        <div className="inner">
          {recommendedList.slice(0, 5).map((item) => (
            <MemoizedPremiumStoreItem
              key={item.id} // index 대신 고유 ID 사용
              item={item}
            />
          ))}
        </div>
      </div>
      <div className="bar" />
    </PremiumStoreListWrapper>
  );
};
